import ViewRIBModal from './ViewRIBModal';
import {Rib} from '../../../interfaces/rib';
import toast from 'react-hot-toast';
import {useIntl} from 'react-intl';
import {createDocuSignSepaUrl, editRib} from '../api';
import {QueryObserverResult, RefetchOptions, RefetchQueryFilters} from 'react-query';
import {Entity} from '../../../modules/auth/authorization/api';
import {useState} from 'react';
import {generateRum} from '../../../common/tools/docusign';
import {useNativeAuth} from '../../../modules/auth/native/NativeAuthProvider';

interface RibModalManagerProps {
  show: boolean;
  hide: () => void;
  rib: Rib;
  entity: Entity;
  refetch: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined
  ) => Promise<QueryObserverResult<Rib>>;
}

const RibModalManager = ({show, hide, rib, entity, refetch}: RibModalManagerProps): JSX.Element => {
  const intl = useIntl();
  const [isRibEdited, setIsRibEdited] = useState(false);
  const [isFetchingDocuSignUrl, setIsFetchingDocuSignUrl] = useState(false);
  const {claims} = useNativeAuth();
  const signerName = claims?.name as string;
  const signerEmail = claims?.preferred_username as string;

  const queryParams = new URLSearchParams(window.location.search);
  const docuSignEventParam = queryParams.get('event');
  const docuSignEnvelopeIdParam = queryParams.get('envelopeId');

  if (
    !isRibEdited &&
    docuSignEventParam !== null &&
    docuSignEnvelopeIdParam !== null &&
    docuSignEventParam === 'signing_complete'
  ) {
    editRib({lineId: rib.lineId, docuSignEnvelopeId: docuSignEnvelopeIdParam}, entity.id)
      .then(() => {
        refetch()
          .then(() =>
            toast.success(
              intl.formatMessage({
                id: 'ADMINISTRATIVE.PAYMENT_MODE.RIB.BANK.FORM.SUCCESS',
              })
            )
          )
          .catch(() =>
            toast.error(
              intl.formatMessage({
                id: 'ADMINISTRATIVE.PAYMENT_MODE.RIB.BANK.FORM.ERROR',
              })
            )
          );
      })
      .catch(() =>
        toast.error(intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_MODE.RIB.BANK.FORM.ERROR'}))
      );
    setIsRibEdited(true);
  }

  const handleSubmit = async () => {
    setIsFetchingDocuSignUrl(true);
    const docuSignUrl = await createDocuSignSepaUrl(
      {
        signerName: signerName ?? '',
        signerEmail: signerEmail ?? '',
        rum: generateRum(entity.id),
        creancier: 'testCreancier',
        returnUrl: window.location.href,
      },
      entity.id
    );
    window.location.replace(docuSignUrl.url);
  };

  return (
    <ViewRIBModal
      rib={rib}
      show={show}
      hide={hide}
      handleSubmit={handleSubmit}
      isFetchingDocuSignUrl={isFetchingDocuSignUrl}
    />
  );
};

export default RibModalManager;
